import { render, staticRenderFns } from "./HandleItemTabGeneral.vue?vue&type=template&id=b25343f6"
import script from "./HandleItemTabGeneral.vue?vue&type=script&lang=js"
export * from "./HandleItemTabGeneral.vue?vue&type=script&lang=js"
import style0 from "./HandleItemTabGeneral.vue?vue&type=style&index=0&id=b25343f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports